(function () {
  'use strict';

  /* failas įtraukiamas iš kelių snippet'o kopijų — init tik kartą */
  if (window.__lsXSell) return;
  window.__lsXSell = 1;

  /* ── Eksperimentas: 50/50 pagal PASTOVŲ lankytojo ID ────────────────────────
     Randomizacijos vienetas — naršyklė, ne sesija ir ne klientas. Klientas netinka:
     didžioji dalis pirkėjų yra svečiai, customer_id jų neturi. Sesija netinka: tas
     pats žmogus šiandien būtų kontrolė, rytoj treatment, ir efektas išsiplautų.

     Kontrolinė grupė nemato rekomendacijų IR negauna porų nuolaidos (_ls_dev
     neuždedamas), bet `eligible` įvykiai jai registruojami — be jų nebūtų vardiklio.
     Pagrindinė metrika: rekomenduotos prekės įdėjimas vienam lankytojui, KURIAM
     SISTEMA TURĖJO KĄ PASIŪLYTI. Ne „vienam eksponuotam": parodymas yra jau
     porandomizacinis rezultatas, ir sąlygojant pagal jį treatment gedimas iš analizės
     pašalintų kaip tik probleminius lankytojus. */
  var EXP = 'xsell_v7';
  var EV_URL = 'https://lipsel.com:3215/xsell/ev';

  function cookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]*)');
    return m ? m.pop() : '';
  }
  function rnd() {
    return Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  }
  var vid = cookie('ls_vid');
  if (!vid) {
    vid = rnd();
    document.cookie = 'ls_vid=' + vid + ';path=/;max-age=7776000;SameSite=Lax';
  }
  var sid = rnd();
  try {
    sid = sessionStorage.getItem('ls_sid') || sid;
    sessionStorage.setItem('ls_sid', sid);
  } catch (e) {}

  /* FNV-1a + murmur3 finalizatorius. Math.random čia negalima — grupė turi būti ta pati
     per visus apsilankymus. Eksperimento pavadinimas maišomas kartu, kad kitas
     eksperimentas skirstytų nepriklausomai.

     Finalizatorius BŪTINAS: gryno FNV-1a žemieji bitai nėra tolygūs, ir `h % 100`
     davė 48,5 % vietoj 50 % (−16 sigmų prie 300 000 ID). Eksperimentas būtų
     startavęs su nelygiomis grupėmis, o tai atrodytų kaip tikras efektas. */
  function bucket(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    h ^= h >>> 16; h = Math.imul(h, 2246822507);
    h ^= h >>> 13; h = Math.imul(h, 3266489909);
    h ^= h >>> 16;
    return (h >>> 0) % 100;
  }
  /* 2026-09-05, Martynas: be 50/50 — VISIEMS, bet iš pradžių tik LT/EE/LV (theme.liquid <html data-ls-market>).
     Ne Baltijos lankytojas = „kontrolė": nemato rekomendacijų, negauna _ls_dev, Function irgi tikrina šalį (cfg.mk). */
  var MARKET_OK = document.documentElement.getAttribute('data-ls-market') === '1';
  var TREAT = MARKET_OK;
  var GROUP = TREAT ? 't' : 'c';

  var algoV = 0;                 /* iš asseto; kol nežinom versijos — nematuojam */
  var queue = [], evTimer = null;
  function ev(t, o) {
    /* `visit` siunčiamas ir be versijos — jis fiksuoja randomizaciją, o ne rekomendaciją.
       Visi kiti įvykiai be žinomos logikos versijos būtų nepriskiriami eksperimentui. */
    if (!algoV && t !== 'visit') return;
    queue.push({
      t: t, vid: vid, sid: sid, exp: GROUP, av: algoV, surface: o.surface || '',
      src: o.src || 0, rec: o.rec || 0, rid: o.rid || '', pos: o.pos || 0,
      pct: o.pct || 0
    });
    if (queue.length >= 20) flush();
    else if (!evTimer) evTimer = setTimeout(flush, 4000);
  }
  function flush() {
    clearTimeout(evTimer); evTimer = null;
    if (!queue.length) return;
    var body = JSON.stringify(queue.splice(0, 50));
    /* keepalive išsiunčia ir uždarant kortelę. sendBeacon netinka: su application/json
       jam reikėtų CORS preflight'o, kurio beacon'as daryti negali. */
    try {
      fetch(EV_URL, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' }, body: body
      }).catch(function () {});
    } catch (e) {}
  }
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  /* Rekomenduota prekė -> atribucijos įrašas; pagal jį atpažįstam įdėjimą į krepšelį,
     nesvarbu ar žmogus paspaudė mūsų „Pridėti", ar nuėjo į prekės puslapį ir įsidėjo pats.
     Kontrolinei grupei tai VIENINTELIS būdas išmatuoti tą patį elgesį.

     Atribucijos taisyklė: PIRMAS tinkamumas per TTL laimi. Ta pati prekė gali būti
     pasiūlyta keliuose paviršiuose (prekės psl., krepšely, drawer'y); perrašinėjant
     įrašą vėlesnis paviršius pasisavintų įdėjimą, kurį iš tikrųjų sukėlė pirmasis.
     Tai iškreiptų paviršių ir pozicijų pjūvius.

     Indeksas — localStorage, ne sessionStorage ir ne atmintis. Žmogus gali pamatyti
     rekomendaciją viename puslapy ir įsidėti prekę jos pačios puslapy arba atsidaryti
     ją NAUJAME skirtuke, o tada sesijos saugykla būtų tuščia ir dalis grandinės dingtų.
     Kontrolinei grupei tai net įprastas kelias — mūsų mygtuko jai nerodom.

     TTL būtinas: be jo priskirtume rekomendacijai ir tokį įdėjimą, kai žmogus po
     valandos pats susirado prekę per paiešką. Tai būtų klaidingai teigiamas rezultatas
     būtent treatment naudai. */
  var STORE = 'ls_recidx', IDX_MAX = 80, TTL = 30 * 60 * 1000;
  function loadIdx() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE) || '{}'), now = Date.now(), out = {};
      Object.keys(raw).forEach(function (k) { if (now - (raw[k].ts || 0) < TTL) out[k] = raw[k]; });
      return out;
    } catch (e) { return {}; }
  }
  function saveIdx() { try { localStorage.setItem(STORE, JSON.stringify(recIndex)); } catch (e) {} }
  var recIndex = loadIdx(), seenElig = {}, seenImp = {}, lastIds = null;

  /* `eligible` — sistemos SPRENDIMAS, ką ji turėjo pasiūlyti. Registruojamas ABIEM
     grupėms iš karto po `pick()`, dar neliečiant HTML: kortelės generavimas gali
     nepavykti (prekė ką tik išparduota, nepublikuota, Section Rendering API neatsakė),
     ir jei tinkamumą fiksuotume tik po sėkmingo renderio, treatment vardiklis būtų
     mažesnis už kontrolės. Vardikliai privalo skaičiuotis iš tų pačių duomenų.

     `impression` — naršyklė iš tikrųjų parodė. Tik treatment. Skirtumas tarp jų yra
     techninis renderio sėkmės rodiklis. */
  function eligible(surface, src, rec, pos, pct) {
    var known = recIndex[rec], rid = known ? known.rid : rnd();
    if (!known) {
      var keys = Object.keys(recIndex);
      if (keys.length >= IDX_MAX) delete recIndex[keys[0]];
      /* pirmas laimi — vėlesni tinkamumai įrašo NEperrašo */
      recIndex[rec] = { rid: rid, surface: surface, src: src || 0, pos: pos || 0,
                        pct: pct || 0, ts: Date.now() };
      saveIdx();
    }
    var k = surface + ':' + rec;
    if (!seenElig[k]) {
      seenElig[k] = 1;
      ev('eligible', { surface: surface, src: src, rec: rec, rid: rid, pos: pos, pct: pct });
    }
    return rid;
  }
  function impress(surface, src, rec, pos, pct) {
    var known = recIndex[rec], rid = known ? known.rid : eligible(surface, src, rec, pos, pct);
    var k = surface + ':' + rec;
    if (!seenImp[k]) {                   /* tas pats blokas per-renderinamas — vienas parodymas */
      seenImp[k] = 1;
      ev('impression', { surface: surface, src: src, rec: rec, rid: rid, pos: pos, pct: pct });
    }
    return rid;
  }
  function noteAdds(cart) {
    var ids = {}, now = Date.now();
    cart.items.forEach(function (i) { ids[i.product_id] = 1; });
    if (lastIds) {
      Object.keys(ids).forEach(function (p) {
        var r = recIndex[p];
        if (!lastIds[p] && r && now - (r.ts || 0) < TTL) {
          ev('add', { surface: r.surface, src: r.src, rec: parseInt(p, 10), rid: r.rid, pos: r.pos, pct: r.pct });
          delete recIndex[p];
          saveIdx();
        }
      });
    }
    lastIds = ids;
  }

  /* Du atskiri įvykiai, nes atsako į du skirtingus klausimus:
       `visit`       — kas buvo randomizuotas. Siunčiamas IŠ KARTO, nelaukiant asseto,
                       kad neprarastume žmonių, uždarančių puslapį po dviejų sekundžių.
       `asset_ready` — ar rekomendacijų duomenys apskritai įsikrovė.
     Sujungus juos į vieną, „lankytojas neatėjo" ir „sistema lūžo" atrodytų vienodai.
     Abu — po vieną sesijai. */
  function once(key, fn) {
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}
    fn();
  }
  once('ls_visit', function () { ev('visit', {}); });

  /* drawer'io kopija per-renderinama (ls-cart.js innerHTML) — konteineriai imami gyvai.
     Konteinerių gali NEBŪT init metu (homepage: vienintelė kopija drawer'y atsiranda po rerender),
     todėl neišeinam anksti — listeneriai ir _ls_dev atributas veikia visada. */
  function containers() {
    return document.querySelectorAll('[data-ls-cross-sell]');
  }
  var srcUrl = (document.currentScript && document.currentScript.getAttribute('data-xsell-src')) || null;
  /* išpardavimo etiketės kolekcijų kortelėms / PDP — ten cross-sell konteinerio (su vertimais) gali nebūti */
  var CLEAR_LABEL = (document.currentScript && document.currentScript.getAttribute('data-clear-label')) || '';
  var CART_NOTE = (document.currentScript && document.currentScript.getAttribute('data-cart-note')) || '';
  var LOWEST_LABEL = (document.currentScript && document.currentScript.getAttribute('data-lowest-label')) || '';

  var recsMap = null;
  /* ženklo taisyklė (asset dv): stumiamos prekės, gaunančios nuolaidą, kai krepšely yra kita to paties ženklo prekė */
  var dvSet = {};
  /* galiojimo išpardavimas: prekės, kurios nespės parsiduot iki galiojimo — nuolaida be poros */
  var clearList = [];

  /* svečių personalizacija: PDP apsilankymai kaupiami localStorage */
  /* tik prekės puslapio blokas: krepšelio langelis (header'yje, pirmas DOM'e) irgi turi data-product-id = pirma krepšelio prekė —
     su prekėmis krepšelyje imdavom JĄ (10-19: išpardavimo žymė dingdavo, ls_viewed pildėsi krepšelio preke) */
  var pdpEl = document.querySelector('[data-ls-cross-sell][data-ls-pdp]');
  if (pdpEl) {
    try {
      var pid = pdpEl.getAttribute('data-product-id');
      var v = JSON.parse(localStorage.getItem('ls_viewed') || '[]').filter(function (x) { return String(x) !== pid; });
      v.unshift(pid);
      localStorage.setItem('ls_viewed', JSON.stringify(v.slice(0, 20)));
    } catch (e) {}
  }

  function viewedIds() {
    try { return JSON.parse(localStorage.getItem('ls_viewed') || '[]'); } catch (e) { return []; }
  }

  /* svoriai: esamas produktas > krepšelio prekės > žiūrėtos prekės; pozicija sąraše irgi sveria.
     layout 'pair' (PDP): TIK esamo produkto poros su realia nuolaida (d>0). */
  function pick(cart, container) {
    var curId = container.getAttribute('data-product-id');
    var limit = parseInt(container.getAttribute('data-limit') || '3', 10);
    var pairOnly = container.getAttribute('data-layout') === 'pair';
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = 1; });

    var scores = {}, items = {};
    /* dealOk: poros nuolaidos badge rodomas TIK kai pora tikrai susidarys — šaltinis krepšely
       arba tai esamas PDP produktas; iš „žiūrėtų" kilusi rekomendacija badge'o negauna */
    function addRecs(srcId, w, dealOk) {
      var rl = recsMap[String(srcId)];
      if (!rl) return;
      rl.forEach(function (r, idx) {
        if (inCart[r.p] || String(r.p) === curId) return;
        scores[r.p] = (scores[r.p] || 0) + w * (3 - Math.min(idx, 2));
        var d = dealOk ? (r.d || 0) : 0;
        var prev = items[r.p];
        if (!prev || d > (prev.d || 0)) {
          items[r.p] = { p: r.p, v: r.v, h: r.h, d: d };
        }
      });
    }
    if (curId) addRecs(curId, 4, true);
    if (!pairOnly) {
      cart.items.forEach(function (it) {
        if (!(it.properties && it.properties._lipsell_gift)) addRecs(it.product_id, 2, true);
      });
      viewedIds().forEach(function (pv) { addRecs(pv, 1, false); });
      /* išpardavimas: svoris tarp krepšelio (2) ir žiūrėtų (1); nuolaida galioja be poros,
         todėl badge visada teisingas */
      clearList.forEach(function (r, idx) {
        if (inCart[r.p] || String(r.p) === curId) return;
        scores[r.p] = (scores[r.p] || 0) + 1.5 * (3 - Math.min(idx, 2));
        if (!items[r.p] || r.d > (items[r.p].d || 0)) items[r.p] = { p: r.p, v: r.v, h: r.h, d: r.d, c: 1 };
      });
    } else {
      /* pair layout: fill remaining slots with regular recs (no deal badge) */
      cart.items.forEach(function (it) {
        if (!(it.properties && it.properties._lipsell_gift)) addRecs(it.product_id, 1, false);
      });
      viewedIds().forEach(function (pv) { addRecs(pv, 0.5, false); });
    }

    if (pairOnly) {
      var sortFn = function (a, b) { return scores[b] - scores[a]; };
      var allKeys = Object.keys(scores);
      var paired = allKeys.filter(function (k) { return items[k].d > 0; }).sort(sortFn);
      var regular = allKeys.filter(function (k) { return !(items[k].d > 0); }).sort(sortFn);
      /* Martynas 09-21: „2–3 nuolaidinės ir 1–2 TOP" — nuolaidinės pirmos, bet viena vieta visada lieka TOP
         (PDP 2+1, krepšelis 3+1, mini 1+1); jei TOP nėra ką rodyti, vietą užima nuolaidinė */
      var maxDeals = regular.length ? Math.max(1, limit - 1) : limit;
      return paired.slice(0, maxDeals).concat(regular).slice(0, limit).map(function (k) { return items[k]; });
    }

    return Object.keys(scores)
      .sort(function (a, b) { return scores[b] - scores[a]; })
      .slice(0, limit)
      .map(function (k) { return items[k]; });
  }

  /* Kortelės = tikros temos product-card (sections/ls-card.liquid) per Section Rendering API —
     kaina, valiuta, kalba, RMK, swatch'ai, dydžiai iš Liquid; JS tik prideda „Pridėti" ir poros badge.
     Kešuojama pagal handle — ta pati prekė cart'e ir drawer'y kraunama vieną kartą. */
  var root = ((window.routes && window.routes.rootUrl) || '/').replace(/\/$/, '');
  var cardCache = {};
  /* variantId — išpardavimo kortelei: nuolaida ir „Pridėti" yra VARIANTO (besibaigianti partija), tad ir
     Liquid turi renderinti tą patį variantą (kaina, pažymėtas dydis), ne pirmą (auditas 2026-09-05) */
  function cardHtml(handle, variantId) {
    var k = handle + (variantId ? ':' + variantId : '');
    if (!cardCache[k]) {
      cardCache[k] = fetch(root + '/products/' + encodeURIComponent(handle) + '?section_id=ls-card' + (variantId ? '&variant=' + variantId : ''), { credentials: 'same-origin' })
        .then(function (r) {
          /* 429/5xx — ne kešuojam tuščios kortelės visam puslapio gyvavimui */
          if (!r.ok) { delete cardCache[k]; return ''; }
          return r.text();
        })
        .then(function (html) {
          var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-item');
          /* nėra kortelės (nepublikuota) arba išparduota → nerekomenduojam */
          return card && !card.classList.contains('product-card--oos') ? card.outerHTML : '';
        })
        .catch(function () { delete cardCache[k]; return ''; });
    }
    return cardCache[k];
  }

  function variantFromUrl(u) {
    var m = /[?&]variant=(\d+)/.exec(u || '');
    return m ? m[1] : null;
  }

  /* addLabel null = be „Pridėti" (Susiję produktai — discovery, kaip native kortelės);
     sizeInTitle = krepšelio psl. eilutė KAIP line-item: „Pavadinimas - 300ml" pavadinime, be chip'o (Martynas 09-05) */
  function decorate(card, c, addLabel, dealLabel, lowestLabel, sizeInTitle, pairLayout) {
    var body = card.querySelector('.product-card__body');
    if (pairLayout) {
      var media = card.querySelector('.product-card__media');
      if (media) {
        var pairDeal = document.createElement('span');
        if (c.d) {
          /* poros nuolaida galioja tik su kodu (Vytautas 09-21) — burbuliuke „Papildomai −5 %" (kodo nerašom — Martynas 09-21: kuponas užsideda pats);
             galiojimo išpardavimas (c.c) taikomas be kodo, jam lieka trumpas „-20%" */
          pairDeal.className = 'ls-cross-sell__deal ls-cross-sell__deal--sale' + (c.c ? '' : ' ls-cross-sell__deal--code');
          pairDeal.textContent = c.c ? '-' + c.d + '%' : dealLabel.replace('__PCT__', c.d);
        } else {
          pairDeal.className = 'ls-cross-sell__deal ls-cross-sell__deal--top';
          pairDeal.textContent = 'TOP';
        }
        media.appendChild(pairDeal);
      }
    } else {
      var priceRow = card.querySelector('.product-card__price-row');
      if (c.d && priceRow) {
        var deal = document.createElement('span');
        deal.className = 'ls-cross-sell__deal';
        deal.textContent = dealLabel.replace('__PCT__', c.d);
        priceRow.appendChild(deal);
      }
    }
    if (body && addLabel) {
      /* kompaktiška eilutė (ls-cart.css): dydžių chip'ai paslėpti, tad pasirinktą dydį rodom žymekliu —
         kortelė renderinta su c.v, t.y. TUO variantu, kurį deda „Pridėti" */
      var sel = card.querySelector('.size-box.is-selected');
      var t = card.querySelector('.product-card__title');
      if (sel && card.querySelectorAll('.size-box').length > 1) {
        if (sizeInTitle && t) {
          t.textContent = t.textContent.trim() + ' - ' + sel.textContent.trim();
        } else {
          var sz = document.createElement('span');
          sz.className = 'ls-cross-sell__size';
          sz.textContent = sel.textContent.trim();
          if (t) t.insertAdjacentElement('afterend', sz); else body.appendChild(sz);
        }
      } else if (sizeInTitle && t) {
        /* spalvos/atspalvio variantai neturi size-box — line-item pavadinimas vis tiek rodo variantą (review 09-06) */
        var sw = card.querySelector('.color-swatch__radio:checked');
        if (sw && card.querySelectorAll('.color-swatch__radio').length > 1) {
          var cv = (sw.value || sw.getAttribute('aria-label') || '').trim();
          if (cv) t.textContent = t.textContent.trim() + ' - ' + cv;
        }
      }
      if (sizeInTitle && c.v) {
        /* pavadinimas žada variantą — nuoroda (ir foto) veda į TĄ variantą, kurį deda „Pridėti" (review 09-06) */
        ['.product-card__title', '.product-item__image-wrapper'].forEach(function (s) {
          var a = card.querySelector(s), h = a && a.getAttribute('href');
          if (h) a.setAttribute('href', h.split('#')[0].split('?')[0] + '?variant=' + parseInt(c.v, 10));
        });
      }
      /* išpardavimas = kainos sumažinimo skelbimas (CK 6.353): šalia badge — mažiausia 30 d. kaina
         (product-card data-lowest-30d, etiketė iš RMK vertimų — jau 17 kalbų) */
      if (c.c && lowestLabel && card.getAttribute('data-lowest-30d')) {
        var low = document.createElement('p');
        low.className = 'ls-cross-sell__lowest';
        low.textContent = lowestLabel + card.getAttribute('data-lowest-30d');
        body.appendChild(low);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ls-cross-sell__add button button--primary button--small';
      btn.setAttribute('data-variant', parseInt(c.v, 10));
      if (c.c) btn.setAttribute('data-clear-variant', parseInt(c.v, 10));
      btn.textContent = addLabel;
      card.appendChild(btn);          /* grid „action" stulpelis — ne body viduje */
    }
    /* wishlist būsena — wishlist.js sinchronizuoja mygtukus tik page load metu */
    card.querySelectorAll('[data-wishlist-btn]').forEach(function (w) {
      var on = !!(window.Wishlist && window.Wishlist.has(parseInt(w.getAttribute('data-wishlist-btn'), 10)));
      w.classList.toggle('wishlist-btn--active', on);
      w.setAttribute('aria-pressed', String(on));
    });
  }

  function parseCard(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.firstElementChild;
  }

  var renderSeq = 0;
  function render(container, cards, surface, src) {
    var list = container.querySelector('.ls-cross-sell__items');
    var addLabel = list.getAttribute('data-add-label') || 'Add';
    var dealLabel = list.getAttribute('data-deal-label') || '−__PCT__%';
    /* išpardavimo kortelė — ne „perkant kartu": nuolaida galioja ir vienai prekei */
    var clearLabel = list.getAttribute('data-clear-label') || dealLabel;
    var lowestLabel = list.getAttribute('data-lowest-label') || '';
    var seq = ++renderSeq;
    container.__lsSeq = seq;
    /* krepšelio psl. eilutės KAIP line-item — pagal layout'ą, ne analitikos surface (jo fallback 'cart' bet kokiam kitam layout'ui) */
    var sizeInTitle = container.getAttribute('data-layout') === 'rows' || container.getAttribute('data-layout') === 'pair';
    var pairLayout = container.getAttribute('data-layout') === 'pair';
    if (!cards.length) { list.innerHTML = ''; container.hidden = true; return; }
    /* VISOS kortelės su c.v: eilutėje chip'ų nėra, tad rodoma kaina ir dydis privalo būti to varianto,
       kurį įdeda „Pridėti" (anksčiau tik išpardavimo kortelė) */
    Promise.all(cards.map(function (c) { return cardHtml(c.h, c.v); })).then(function (htmls) {
      /* per tą laiką konteineris per-renderintas (drawer) arba atėjo naujesnis sync — nebeliečiam */
      if (container.__lsSeq !== seq || !document.body.contains(container)) return;
      list.innerHTML = '';
      var n = 0;
      htmls.forEach(function (html, i) {
        if (!html) return;
        var card = parseCard(html);
        decorate(card, cards[i], addLabel, cards[i].c ? clearLabel : dealLabel, lowestLabel, sizeInTitle, pairLayout);
        /* parodymas registruojamas tik kai kortelė TIKRAI įdedama: tuščias HTML reiškia
           nepublikuotą arba išparduotą prekę, ir jos niekas nematė */
        card.setAttribute('data-ls-rid', impress(surface, src, cards[i].p, i, cards[i].d || 0));
        list.appendChild(card);
        n++;
      });
      container.hidden = n === 0;
      /* card-scroller.js: dydžių „+N" sutalpinimas įdėtoms kortelėms */
      if (n) document.dispatchEvent(new CustomEvent('ls:cards'));
    });
  }

  /* „Susiję produktai" (sections/product-recommendations, Shopify native, tema krauna AJAX'u ir keičia
     .product-recommendations innerHTML be evento): papildom esamo produkto co-purchase prekėm —
     mūsų kortelės (su poros badge) PIRMOS, native užpildo likutį, dublikatai lauk, max 10.
     Vienas rekomendacijų blokas PDP'e vietoj dviejų. */
  var RELATED_MAX = 10, RELATED_OURS = 4;
  function mergeRelated() {
    if (!recsMap || !pdpEl) return;
    var sec = document.querySelector('[data-section-type="product-recommendations"]');
    var list = sec && sec.querySelector('.product-list');
    if (!list || list.dataset.lsMerged || !list.querySelector('.product-card')) return;
    var relSrc = parseInt(pdpEl.getAttribute('data-product-id') || '0', 10);
    /* „Pigiau kartu" virš mygtukų jau rodo poras su nuolaida — „Susijusiuose" tų pačių nekartojam (Martynas 09-05).
       Pair blokas renderinamas asinchroniškai, tad imam tai, ką pick() jam parinktų (tuščias krepšelis = superaibė). */
    var shown = {};
    pick({ items: [] }, pdpEl).forEach(function (r) { shown[String(r.p)] = 1; });
    var ours = (recsMap[String(relSrc)] || []).filter(function (r) { return !shown[String(r.p)]; }).slice(0, RELATED_OURS);
    list.dataset.lsMerged = '1';
    /* native „Susiję" kortelės su pair prekėmis — irgi lauk */
    list.querySelectorAll('.product-card[data-product-id]').forEach(function (c) { if (shown[c.getAttribute('data-product-id')]) c.remove(); });
    if (!ours.length) return;
    /* tinkamumas abiem grupėms prieš renderinimą — kaip ir kituose paviršiuose */
    ours.forEach(function (r, i) { eligible('related', relSrc, r.p, i, r.d || 0); });
    /* kontrolė mato native „Susijusius produktus", bet ne mūsų co-purchase korteles */
    if (!TREAT) return;
    var dealLabel = pdpEl.querySelector('.ls-cross-sell__items').getAttribute('data-deal-label') || '−__PCT__%';
    Promise.all(ours.map(function (r) { return cardHtml(r.h); })).then(function (htmls) {
      if (!document.body.contains(list)) return;
      var oursIds = {};
      var frag = document.createDocumentFragment();
      htmls.forEach(function (html, i) {
        if (!html) return;
        var card = parseCard(html);
        card.setAttribute('data-ls-xsell', '1');
        card.setAttribute('data-ls-rid', impress('related', relSrc, ours[i].p, i, ours[i].d || 0));
        oursIds[String(ours[i].p)] = 1;
        decorate(card, { d: ours[i].d || 0 }, null, dealLabel);
        frag.appendChild(card);
      });
      /* native dublikatai (tas pats product id per wishlist mygtuką) lauk */
      list.querySelectorAll('.product-card:not([data-ls-xsell])').forEach(function (c) {
        var w = c.querySelector('[data-wishlist-btn]');
        if (w && oursIds[w.getAttribute('data-wishlist-btn')]) c.remove();
      });
      list.insertBefore(frag, list.firstChild);
      var all = list.querySelectorAll('.product-card');
      for (var i = RELATED_MAX; i < all.length; i++) all[i].remove();
      document.dispatchEvent(new CustomEvent('ls:cards'));
      /* card-scroller nav (rodyklės/thumb) persiskaičiuoja per resize */
      window.dispatchEvent(new Event('resize'));
    });
  }
  if (pdpEl && typeof MutationObserver !== 'undefined') {
    var relSec = document.querySelector('[data-section-type="product-recommendations"]');
    if (relSec) new MutationObserver(mergeRelated).observe(relSec, { childList: true, subtree: true });
  }

  /* Assetas v2: {v:2, idx:{pid:[handle, variantId]}, r:{src:[[pid, nuolaidos_%], ..]}}.
     Tie patys taikiniai kartojasi šimtuose sąrašų, todėl handle ir variantas laikomi po kartą —
     plokščias v1 formatas su 767 prekių aprėptim būtų 400 KB. Išskleidžiam į seną {p,v,h,d} formą. */
  function expand(m) {
    if (m && m.av) algoV = m.av;
    if (!m || m.v !== 2 || !m.r || !m.idx) return m || {};
    var out = {};
    Object.keys(m.r).forEach(function (src) {
      var list = [];
      m.r[src].forEach(function (e) {
        var i = m.idx[e[0]];
        if (i) list.push({ p: e[0], v: i[1], h: i[0], d: e[1] || 0 });
      });
      if (list.length) out[src] = list;
    });
    clearList = [];
    (m.c || []).forEach(function (e) {
      var i = m.idx[e[0]];
      if (i) clearList.push({ p: e[0], v: i[1], h: i[0], d: e[1] || 0 });
    });
    /* rotacija per lankytoją: blokas rodo 2-3 korteles, be rotacijos parodymų gautų tik
       trys pirmos išpardavimo prekės, likusios niekada */
    if (clearList.length > 1) {
      var off = bucket(vid + ':clear') % clearList.length;
      clearList = clearList.slice(off).concat(clearList.slice(0, off));
    }
    return out;
  }

  var SURFACE = { pair: 'product', mini: 'drawer', rows: 'cart' };
  function surfaceOf(c) { return SURFACE[c.getAttribute('data-layout')] || 'cart'; }

  /* Kuponas SUPER prisideda pats (Martynas 09-21): porų nuolaida Function'e pririšta prie kodo, bet pirkėjui
     jo vesti nereikia — kai krepšelyje susidaro pora su nuolaida, kodą uždedam per /cart/update.js; porai
     iširus — nuimam (kitaip kasoje kabotų „kodas netaikomas"). Pirkėjo paties įvesto kito kodo neliečiam.
     sessionStorage žymė — vienas bandymas tai pačiai krepšelio būsenai, kad atmestas kodas nesuktų reload ciklo. */
  var PAIR_CODE = 'SUPER';
  function syncCode(cart) {
    if (!recsMap || window.__lsEmailAdd) return;   /* laiško „Į krepšelį" dar deda — perkrovimas nutrauktų */
    var inCart = {}, vend = {};
    cart.items.forEach(function (it) { if (!(it.properties && it.properties._lipsell_gift)) { inCart[it.product_id] = 1; vend[it.product_id] = it.vendor || ''; } });
    var pair = TREAT && Object.keys(inCart).some(function (pid) {
      if ((recsMap[pid] || []).some(function (r) { return r.d > 0 && inCart[r.p]; })) return true;
      /* ženklo taisyklė: stumiama prekė + kita to paties ženklo prekė (nebūtinai iš rekomendacijų sąrašo) */
      return dvSet[pid] && vend[pid] && Object.keys(inCart).some(function (o) { return o !== pid && vend[o] === vend[pid]; });
    });
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var has = codes.some(function (c) { return String(c).toUpperCase() === PAIR_CODE; });
    if (pair === has || (pair && codes.length)) return;
    var state = [cart.token, pair, cart.item_count, codes.join(',')].join('|');
    try { if (sessionStorage.getItem('ls_code_try') === state) return; sessionStorage.setItem('ls_code_try', state); } catch (e) {}
    var next = pair ? [PAIR_CODE] : codes.filter(function (c) { return String(c).toUpperCase() !== PAIR_CODE; });
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: next.join(',') })
    }).then(function (r) {
      if (!r.ok) return;
      document.dispatchEvent(new CustomEvent('cart:sync'));
      if (window.theme && window.theme.pageType === 'cart') window.location.reload();
    }).catch(function () {});
  }

  var busy = false;
  function sync() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = cart.attributes || {}, attrs = {};
        /* develop žymė Function'ui: porų nuolaidos veikia tik su šiuo atributu.
           Kontrolinei grupei jo neuždedam, o radę seną — nuimam: kontrolė turi
           negauti nuolaidos net jei anksčiau buvo treatment. */
        if (TREAT && a._ls_dev !== '1') attrs._ls_dev = '1';
        if (!TREAT && a._ls_dev) attrs._ls_dev = '';
        /* grupė ir logikos versija keliauja į krepšelio atributus, iš ten į užsakymą —
           taip pirkimo pusę matuojam iš užsakymų, be atskiro webhook'o. */
        if (a._ls_exp !== GROUP) attrs._ls_exp = GROUP;
        if (algoV && String(a._ls_av || '') !== String(algoV)) attrs._ls_av = String(algoV);
        /* Martynas 2026-10-22: susieti rekomendacijų įdėjimus su užsakymais – lankytojo ID keliauja į užsakymą,
           porų ataskaita (xsell_pairs.py) jungia `add` įvykius (vid+rec) su užsakymo prekėmis */
        if (a._ls_vid !== vid) attrs._ls_vid = vid;
        if (Object.keys(attrs).length) {
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).then(function () {
            /* ls-free-gift.js: dovanos tik su _ls_dev - jo sync'as galejo ivykti dar pries si irasa */
            document.dispatchEvent(new CustomEvent('ls:attrs'));
          }).catch(function () {});
        }
        if (recsMap) {
          containers().forEach(function (c) {
            /* cart paviršiuose tuščias krepšelis = nieko nerodom; PDP rodom visada */
            if (!cart.items.length && !c.getAttribute('data-product-id')) { c.hidden = true; return; }
            var cards = pick(cart, c), sf = surfaceOf(c), src = parseInt(c.getAttribute('data-product-id') || '0', 10);
            /* tinkamumas — ABIEM grupėms ir PRIEŠ renderinimą, kad vardiklis nepriklausytų
               nuo to, ar pavyks sugeneruoti kortelę */
            cards.forEach(function (x, i) { eligible(sf, src, x.p, i, x.d || 0); });
            if (TREAT) {
              render(c, cards, sf, src);
            } else {
              c.hidden = true;   /* kontrolė nieko nemato */
            }
          });
        }
        syncCode(cart);
        noteAdds(cart);
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  /* PDP „Pigiau kartu": nuolaida atsiranda tik kai krepšely ABI prekės, todėl mygtukas deda
     ir žiūrimą prekę. Kitaip badge žada -10 %, o krepšely lieka viena prekė be nuolaidos. */
  /* Formą imam iš TOS PAČIOS sekcijos kaip blokas — puslapy gali būt ir kitų /cart/add formų
     (quick view, „complete the look"), o jų variantas būtų ne šio produkto. */
  function pdpVariantId(pair) {
    var scope = pair.closest('.shopify-section') || document;
    var el = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
             document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = el && parseInt(el.value, 10);
    return id || null;
  }

  function itemsToAdd(btn) {
    var rec = { id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 };
    var pair = btn.closest('[data-ls-cross-sell][data-layout="pair"]');
    var cur = pair && pdpVariantId(pair);
    if (!cur || cur === rec.id) return Promise.resolve([rec]);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = cart.items.some(function (i) { return i.variant_id === cur; });
        return have ? [rec] : [{ id: cur, quantity: 1 }, rec];
      })
      .catch(function () { return [rec]; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ls-cross-sell__add');
    if (!btn) return;
    btn.disabled = true;
    function add(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }

    itemsToAdd(btn).then(function (items) {
    /* items masyvas atomiškas: jei žiūrimos prekės variantas jau išparduotas, kristų ir
       rekomendacija — mygtukas atrodytų neveikiantis. Nepavykus dedam bent rekomendaciją. */
    return add(items).then(function (r) {
      if (!r.ok && items.length > 1) {
        items = items.slice(-1);
        return add(items);
      }
      return r;
    }).then(function (r) {
      if (!r.ok) { btn.disabled = false; return; }
      if (window.theme && window.theme.pageType === 'cart') {
        window.location.reload();
      } else {
        /* Tema klauso per Delegate(document.documentElement) ir handleris skaito
           event.detail.quantity. Ant `document` siųstas įvykis <html> nepasiekia (bubbling
           kyla AUKŠTYN), o be detail handleris lūžta — abiem atvejais header'io krepšelio
           skaitliukas lieka senas ir atrodo, kad „Pridėti" neveikia.
           Kontraktas dokumentuotas temos custom.js. Iš documentElement įvykis pakyla
           iki document, tad mūsų pačių listeneriai (ls-cart, ls-free-gift) irgi gauna. */
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: items.length }
        }));
      }
    });
    }).catch(function () { btn.disabled = false; });
  });

  /* paspaudimas bet kur kortelėje — nuoroda, foto ar „Pridėti". Naudojam TIK diagnostikai:
     CTR gali būti aukštas ir prastoms rekomendacijoms, todėl sėkmės matas yra įdėjimas. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ls-rid]');
    if (!card) return;
    var r = null, rid = card.getAttribute('data-ls-rid');
    for (var p in recIndex) if (recIndex[p].rid === rid) { r = recIndex[p]; r.rec = parseInt(p, 10); break; }
    if (r) ev('click', { surface: r.surface, src: r.src, rec: r.rec, rid: rid, pos: r.pos, pct: r.pct });
  }, true);

  /* dydžio / spalvos pasirinkimas kortelėj → „Pridėti" ima pasirinktą variantą.
     Spalvos foto keičiam patys: temos ProductItem delegatas gyvena tik kolekcijų/rekomendacijų sekcijose. */
  function setVariant(card, url) {
    var id = variantFromUrl(url), btn = card && card.querySelector('.ls-cross-sell__add');
    if (id && btn) btn.setAttribute('data-variant', id);
    /* išpardavimo nuolaida yra VARIANTO: pasirinkus kitą dydį badge'as nuimamas — Function jos netaikys */
    var cv = btn && btn.getAttribute('data-clear-variant');
    if (id && cv) {
      var deal = card.querySelector('.ls-cross-sell__deal');
      if (deal) deal.hidden = String(id) !== String(cv);
    }
  }
  document.addEventListener('click', function (e) {
    var box = e.target.closest('.ls-cross-sell .size-box');
    if (box && !box.classList.contains('sold-out')) setVariant(box.closest('.product-card'), box.getAttribute('data-variant-url'));
  });
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('.ls-cross-sell .color-swatch__radio');
    if (!radio) return;
    var card = radio.closest('.product-card');
    var url = radio.getAttribute('data-variant-url');
    setVariant(card, url);
    var img = card.querySelector('.product-item__primary-image');
    var src = radio.getAttribute('data-image-url');
    if (img && src && radio.getAttribute('data-media-id') !== img.getAttribute('data-media-id')) {
      img.setAttribute('src', src.replace('{width}', '400'));
      img.removeAttribute('srcset');
      img.setAttribute('data-media-id', radio.getAttribute('data-media-id'));
    }
    if (url) card.querySelectorAll('a.product-item__title, a.product-item__image-wrapper').forEach(function (a) { a.setAttribute('href', url); });
  });

  document.addEventListener('cart:rerendered', function () { setTimeout(sync, 150); });
  /* be šito įdėjimas iš mūsų mygtuko PDP'e liktų nepastebėtas iki kito puslapio */
  document.addEventListener('product:added', function () { setTimeout(sync, 400); });

  /* PDP: išpardavimo nuolaidą taiko Function tik krepšelyje, tad prekės puslapis rodytų įprastą kainą ir
     pirkėjas apie −20 % nesužinotų (Martynas 09-05, Filorga SKIN-UNIFY). Prie kainos — badge + kaina krepšelyje.
     Nuolaida yra VARIANTO: pakeitus dydį perskaičiuojam arba slepiam. Etiketės — iš „Pigiau kartu" konteinerio
     (renderinamas tik LT/EE/LV, kaip ir pati nuolaida). */
  function money(cents) {
    var fmt = (window.theme && (window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat)) || '{{amount_with_comma_separator}} €';
    var p = (cents / 100).toFixed(2).split('.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',' + p[1]);
  }
  function pdpClearance() {
    if (!MARKET_OK || !window.theme || window.theme.pageType !== 'product') return;
    var pc = document.querySelector('.product-form__info-content .price-card');
    var pair = pdpEl;
    if (!pc || !pair || pc.querySelector('.ls-clear-pdp')) return;
    var pid = pair.getAttribute('data-product-id'), entry = null;
    for (var i = 0; i < clearList.length; i++) if (String(clearList[i].p) === String(pid)) { entry = clearList[i]; break; }
    if (!entry) return;
    var items = pair.querySelector('.ls-cross-sell__items');
    var clearLabel = items.getAttribute('data-clear-label') || CLEAR_LABEL;
    var box = document.createElement('div');
    box.className = 'ls-clear-pdp';
    box.hidden = true;
    box.innerHTML = '<span class="ls-cross-sell__deal"></span><span class="ls-clear-pdp__price"></span><span class="ls-clear-pdp__note"></span><span class="ls-clear-pdp__lowest"></span>';
    box.querySelector('.ls-clear-pdp__note').textContent = CART_NOTE;
    pc.appendChild(box);
    /* CK 6.353: kainos sumažinimo skelbimas — šalia mažiausia 30 d. kaina. Temos RMK blokas ją rodo tik kai prekė
       turi custom.rrp (product-variant-selector.liquid); be RMK — rodom patys iš window.__omnibusLowest (review 09-05). */
    function update(variantId, priceCents) {
      var on = String(variantId) === String(entry.v);
      box.hidden = !on;
      if (!on) return;
      box.querySelector('.ls-cross-sell__deal').textContent = clearLabel.replace('__PCT__', String(entry.d));
      box.querySelector('.ls-clear-pdp__price').textContent = money(Math.round(priceCents * (100 - entry.d) / 100));
      var rrpBlock = document.querySelector('.js-rrp-block'), low = box.querySelector('.ls-clear-pdp__lowest');
      var rrpShown = rrpBlock && rrpBlock.style.display !== 'none';
      low.hidden = !!rrpShown || !LOWEST_LABEL;
      if (!low.hidden) {
        var lc = (window.__omnibusLowest || {})[variantId];
        low.textContent = LOWEST_LABEL + money(lc == null ? priceCents : lc);
      }
    }
    var idEl = document.querySelector('.product-form [name="id"]');
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variants = meta && meta.variants;
    /* Brave / reklamų blokatoriai ShopifyAnalytics nuima → be šito žymė nepasirodydavo (Martynas 10-19, Noreva micellar).
       Atsarga — temos prekės JSON (snippets/product-info.liquid), kainos ten irgi centais. */
    if (!variants) {
      try { variants = JSON.parse(document.querySelector('[data-product-json]').textContent).product.variants; } catch (e) {}
    }
    var v0 = null;
    if (idEl) (variants || []).forEach(function (v) { if (String(v.id) === String(idEl.value)) v0 = v; });
    if (v0) update(v0.id, v0.price);
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v) update(v.id, v.price);
    });
  }

  /* Kolekcijos / paieška / „Susiję": temos kortelė be etiketės — pirkėjas nesužinotų, kad prekė išparduodama
     (Martynas 09-05, Filorga kolekcija). Badge ant foto kaip temos product-label; kelių dydžių prekei — su dydžiu,
     nes nuolaida yra VARIANTO. Kortelės po filtrų / infinite scroll perpiešiamos → kartojam per theme:loading:end. */
  function decorateCatalogCards() {
    if (!MARKET_OK || !clearList.length || !CLEAR_LABEL) return;
    var byPid = {};
    clearList.forEach(function (e) { byPid[String(e.p)] = e; });
    document.querySelectorAll('.product-card[data-product-id]').forEach(function (card) {
      if (card.closest('.ls-cross-sell') || card.querySelector('.product-label--clear')) return;
      var e = byPid[card.getAttribute('data-product-id')];
      if (!e) return;
      var media = card.querySelector('.product-card__media');
      if (!media) return;
      var size = '';
      var box = card.querySelector('.size-box[data-variant-url*="variant=' + e.v + '"]');
      if (box) size = ' · ' + box.textContent.trim();
      var badges = media.querySelector('.product-card__badges');
      if (!badges) { badges = document.createElement('div'); badges.className = 'product-card__badges'; media.appendChild(badges); }
      var lab = document.createElement('span');
      lab.className = 'product-label product-label--clear';
      lab.textContent = CLEAR_LABEL.replace('__PCT__', String(e.d)) + size;
      badges.appendChild(lab);
    });
  }
  document.addEventListener('theme:loading:end', function () { setTimeout(decorateCatalogCards, 60); });

  /* CRM laiško „Į krepšelį" (2026-09-22). Nuo 09-23 prekes į krepšelį deda PATS Shopify: laiško nuoroda —
     /cart/add?id=V&properties[_ls_em]=<žymė>&return_to=/cart?ls_em=<žymė> (kelioms — items[i][…]), be jokio JS
     (Martynas 09-22 Brave naršyklėje: „neveikia" — JS kelias tyliai nesuveikė). Čia lieka du darbai:
       1. /cart?ls_em=<žymė> (jau įdėta) — Function nuolaidą duoda tik su krepšelio atributu _ls_dev, kurį
          uždeda šis JS; naujam krepšeliui puslapis jau atvaizduotas BE nuolaidos → uždedam atributą ir
          perkraunam VIENĄ kartą (jei atributas jau buvo — tik nuimam parametrą iš URL);
       2. senos nuorodos (laiškai iki 09-23): /products/x?variant=V&ls_em=… ir /cart?ls_add=V1,V2&ls_em=… —
          dedam per /cart/add.js kaip anksčiau.
     Eilutės savybė _ls_em: Function pažymėtai eilutei duoda porų/ženklo nuolaidą be partnerio krepšely
     (pirkėjas jį jau turi, pirko anksčiau; žymė galioja ~2 mėn., config `em`).
     ⚠️ Krepšelio puslapy tuo pačiu metu sukasi syncCode() ir ls-free-gift.js, kurie PERKRAUNA puslapį —
     kol dedam, window.__lsEmailAdd juos stabdo. Prieš dedant žiūrim, kas jau krepšely su ta žyme
     (pakartotas paspaudimas nedubliuoja); sessionStorage žymės NEBĖRA — pasenusi žymė tyliai blokuodavo.
     Matavimas (09-23): iš /cart?ls_em= CRM pranešam, ką klientas PAMATĖ — pažymėtas eilutes su kaina prieš/po
     nuolaidų (be asmens duomenų, POST links.lipsell.com/crm/em). CRM lygina su tuo, ką Function turėjo duoti;
     nesutapimas = klaida, kurios mūsų testai nerodo (Martynas: „iš kur iš tikrųjų žinoti, kad veikia?"). */
  var EM_REPORT_URL = 'https://links.lipsell.com/crm/em';
  function emailAdd() {
    if (!window.theme) return;
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var mark = q.get('ls_em');
    if (!mark || !/^[0-9a-f]{6,32}$/i.test(mark)) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function post(url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    }
    function stripUrl() {
      q.delete('ls_em'); q.delete('ls_add');
      try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash); } catch (e) {}
    }
    function report(c) {
      try {
        var lines = (c.items || []).filter(function (it) { return it.properties && it.properties._ls_em === mark; }).map(function (it) {
          var t = (it.line_level_discount_allocations || []).map(function (x) { return (x.discount_application && x.discount_application.title) || ''; }).join(',');
          return { v: it.variant_id, p: it.product_id, q: it.quantity, c: it.original_line_price, f: it.final_line_price, t: t };
        });
        var body = new URLSearchParams();
        body.append('d', JSON.stringify({ m: mark, cur: c.currency || '', dev: (c.attributes || {})._ls_dev === '1', n: (c.items || []).length, lines: lines }));
        var sent = false;
        try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(EM_REPORT_URL, body)); } catch (e) {}
        if (!sent) fetch(EM_REPORT_URL, { method: 'POST', body: body, mode: 'no-cors', keepalive: true, credentials: 'omit' }).catch(function () {});
      } catch (e) {}
    }
    var ids = [];
    if (q.get('ls_add')) {
      ids = q.get('ls_add').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean).slice(0, 8);
    } else if (window.theme.pageType === 'product') {
      ids = [parseInt(q.get('variant') || '0', 10)].filter(Boolean);
    }
    window.__lsEmailAdd = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = cart.attributes || {};
        var needAttr = TREAT && a._ls_dev !== '1';
        /* update.js grąžina krepšelį jau SU Function nuolaidomis (atributas uždėtas) — iš jo ir pranešam */
        var attrs = needAttr
          ? post('/cart/update.js', { attributes: { _ls_dev: '1' } }).then(function (r) { return r.ok ? r.json() : cart; }).catch(function () { return cart; })
          : Promise.resolve(cart);
        if (!ids.length) {
          /* 1. prekės jau įdėtos serverio pusėje — tik nuolaidos atvaizdavimas ir pranešimas CRM */
          return attrs.then(function (c) { report(c); return needAttr ? 'reload' : 'strip'; });
        }
        /* 2. senos nuorodos — dedam patys */
        var have = {};
        (cart.items || []).forEach(function (it) { if (it.properties && it.properties._ls_em === mark) have[it.variant_id] = 1; });
        var todo = ids.filter(function (id) { return !have[id]; });
        function add(list) {
          return post('/cart/add.js', { items: list.map(function (id) { return { id: id, quantity: 1, properties: { _ls_em: mark } }; }) });
        }
        if (!todo.length) return 'cart';
        return attrs.then(function () { return add(todo); }).then(function (r) {
          if (r && r.ok) return 'cart';
          if (todo.length < 2) return '';
          return todo.reduce(function (chain, id) {
            return chain.then(function (any) { return add([id]).then(function (x) { return any || !!(x && x.ok); }, function () { return any; }); });
          }, Promise.resolve(false)).then(function (any) { return any ? 'cart' : ''; });
        });
      })
      .then(function (next) {
        window.__lsEmailAdd = false;
        if (next === 'strip') stripUrl();
        else if (next === 'reload' || next === 'cart') { stripUrl(); window.location.replace(root + 'cart'); }
      })
      .catch(function () { window.__lsEmailAdd = false; });
  }
  emailAdd();

  var c0 = containers()[0];
  if (!srcUrl && c0) srcUrl = c0.getAttribute('data-src');
  if (srcUrl) {
    fetch(srcUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (m) {
        (m && m.dv || []).forEach(function (id) { dvSet[String(id)] = 1; });
        recsMap = expand(m);
        once('ls_asset', function () { ev('asset_ready', {}); });
        sync();
        mergeRelated();
        pdpClearance();
        decorateCatalogCards();
      })
      .catch(function () { sync(); });     /* assetas nepasiekiamas — `asset_ready` nebus */
  } else {
    sync();
  }
})();
